/* Redux */
import { useSelector, useDispatch } from 'src/redux/hooks'

/* Types */
import { tProductPreview } from 'src/shared/frontendTypes/product'
import type { tItem } from 'src/shared/frontendTypes/warenkorb'

const Redux = () => {

  /* ------------------------------------------------------ */
  const items = useSelector(store => store.Wunschliste.items)

  const dispatch = useDispatch()

  const deleteItem = (key: string) => 
    dispatch({ type: 'removeWunschlisteItem', payload: key })

  /* ------------------------------------------------------ */
  const products = useSelector(store => store.Wunschliste.products)
  const cartItems = useSelector(store => store.Warenkorb.items)
  const addCartItem = (item: tItem) => dispatch({ type: 'addWarenkorbItem', payload: item })

  const dispatchProducts = (products: tProductPreview[]) =>
    dispatch({ type: 'updateWunschlisteProducts', payload: products })

  /* ------------------------------------------------------ */

  return { 
    items, deleteItem,
    products, dispatchProducts, cartItems, addCartItem
  }
  
}

export default Redux
